export const FORM_NAME = 'SUPPORTIVE_CARE_PLAN_FORM';
